import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private apiCount = 0;
  public isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  constructor() {}

  showLoader() {
    this.setLoading(true);
    this.apiCount++;
  }

  hideLoader() {
    this.apiCount--;
    this.setLoading(false);
  }

  private setLoading(isLoading: boolean) {
    if (this.apiCount === 0) {
      this.isLoadingSubject.next(isLoading);
    }
  }
}
